import { ILoginForm } from "../../interfaces/login/ILoginForm";
import { cryptoPortfolioService } from "../../services/httpService/cryptoPorfolio.service";

export async function tryLogin(login: ILoginForm) {
    return await cryptoPortfolioService.post('/user/login', login);
}